<div class="row float-start bg-white position-fixed h-100 pt-3 mt-n4 d-none d-sm-block d-md-block d-lg-block">
    <div class="col-sm-2 col-md-2 col-lg-1 col-xl-1 pe-0">
        <nav class="navbar navbar-light navbar-expand-sm px-0 flex-row flex-nowrap left-nav">
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarWEX"
                aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"
                data-testid="shared.navbar.mobile-toggle">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="navbar-collapse collapse" id="navbarWEX">
                <div class="nav flex-sm-column flex-row">
                    <a [ngClass]="{'selected':selectedPage.title == '/dashboard'}" title="Dashboard"
                        class="cursor-pointer" (click)="setCurrentNav('Dashboard')"
                        data-testid="shared.navbar.dashboard-link" aria-label="Dashboard"><i class="fa fa-briefcase" aria-hidden="true"></i></a>
                    <a [ngClass]="{'selected':selectedPage.title == '/tasks'}" title="TODO"
                        class="cursor-pointer" (click)="setCurrentNav('Tasks')"
                        data-testid="shared.navbar.tasks-link" aria-label="TODO">
                        <i class="fa fa-check" aria-hidden="true"></i>
                        <div class="notification-div" >
                            {{taskPendingCount}}
                        </div>
                    </a>
                    <a [ngClass]="{'selected':selectedPage.title == '/profile'}" title="Profile" class="cursor-pointer"
                        (click)="setCurrentNav('Profile')"
                        data-testid="shared.navbar.profile-link" aria-label="Profile"><i class="fa fa-user-circle-o" aria-hidden="true"></i></a>
                    <a [ngClass]="{'selected':currentIndex == 3}" title="Portfolio"
                        class="cursor-pointer" (click)="openPortfolio()"
                        data-testid="shared.navbar.portfolio-link" aria-label="Portfolio"><i class="fa fa-pie-chart" aria-hidden="true"></i></a>
                    <a [ngClass]="{'selected':selectedPage.title == '/documents'}" title="Documents"
                        class="cursor-pointer" (click)="setCurrentNav('Documents')"
                        data-testid="shared.navbar.documents-link" aria-label="Documents"><i class="fa fa-file-text" aria-hidden="true"></i>
                        <div class="notification-div" >
                            {{documentCount}}
                        </div>
                    </a>
                    <a *ngIf="showNewsIcon" ng-class="{'selected':currentIndex == 4}" title="News & Insights"
                        class="cursor-pointer" (click)="openKnowledgeBase()"
                        data-testid="shared.navbar.news-link" aria-label="News & Insights">
                        <i class="fa fa-newspaper-o" aria-hidden="true"></i></a>
                    <a (click)="logOut()" class="cursor-pointer" title="Sign out"
                        data-testid="shared.navbar.signout-link" aria-label="Sign out"><i class="fa fa-sign-out" aria-hidden="true"></i></a>
                </div>
            </div>
        </nav>
    </div>
</div>
